<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <template v-if="data">
      <div class="topRect">
        <div class="title">
          {{ data.place.placeName }}
        </div>
        <van-rate v-model="data.score" allow-half readonly class="star" size="1em" :color="GetDiveMainBack()" /><span v-if="data.score<=0" class="noScore">暂无评分</span>
        <div class="addressLine">{{ data.place.country }}&nbsp;{{ data.place.areaName }}</div>
        <div class="addressLine" :style="'color:'+GetDiveMainBack()">{{ data.place.country }}&nbsp;{{ data.place.areaNameEng }}</div>
        <div class="mapRect">
          <baidu-map
            class="rectMap"
            :center="center"
            :zoom="zoom"
          >
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
            <bm-marker :position="centerEnd" :dragging="false" :icon="{url: '/img/mapPointB.png', size: {width: 19, height: 25}}" />
            <bm-marker :position="center" :dragging="false" :icon="{url: '/img/mapPointA.png', size: {width: 19, height: 25}}" />
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :show-address-bar="true" :auto-location="true" />
          </baidu-map>
        </div>
        <div class="about">{{ data.place.about }}</div>
      </div>
      <div v-if="data.ress && data.ress.length>0" class="baseRect">
        <div class="title">
          图片
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          PICTURE
        </div>
        <div class="about">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(image, index) in data.ress" :key="index">
              <van-image
                width="100%"
                height="60vw"
                lazy-load
                fit="scale-down"
                :src="image"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>

      <div v-if="data.place.fishAbout" class="baseRect">
        <div class="title">
          生物介绍
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          BIOLOGICAL INTRODUCTION
        </div>

        <div class="about">
          {{ data.place.fishAbout }}
        </div>
      </div>

      <div class="baseRect">
        <div class="title">
          生物种类
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          BIOLOGICAL SPECIES
        </div>
        <div v-if="biologyList.length<=0" class="emptyRect">
          暂无数据
        </div>
        <div class="dataRect">
          <div v-for="(item,index) in biologyList" :key="item.biology.fishId" class="rect" :style="index%2===0?'margin-right:0.5em':'margin-left:0.5em'">
            <van-image
              class="img"
              width="100%"
              height="30vw"
              lazy-load
              :src="item.biology.img && item.biology.img.length>0?item.biology.img[0]:'/dive/defaultFish.jpg'"
              fit="cover"
              radius="0.4em"
              @click="onSelectFish(item.fishPlaceRelationId)"
            />
            <div class="name" @click="onSelectFish(item.fishPlaceRelationId)">{{ item.biology.name }}
            </div>
            <div class="from">
              <van-tag v-for="dp in item.divePlaceList" :key="dp.divePlaceId" plain :color="GetDiveMainBack()" @click="onSelectPlace(dp.divePlaceId)">{{ dp.placeName }}</van-tag>
            </div>
          </div>
        </div>
      </div>
      <div v-if="GetEnbaleDiveComment()" class="baseRect">
        <div class="title">
          点评
          <div style="float:right" @click="showAddComment=true"><i class="iconfont iconadd" /></div>
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          REVIEWS
        </div>
        <diveCommentList v-model="commentId" :comment-type="commentType" />
        <diveCommentAdd v-model="showAddComment" :comment-id="commentId" :comment-type="commentType" />
      </div>
    </template>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Rate, Image, Lazyload, Tag, Swipe, SwipeItem } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetEnbaleDiveComment, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import diveCommentList from '@/components/diveCommentList'
import diveCommentAdd from '@/components/diveCommentAdd'

export default {
  components: {
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    TopBar,
    diveCommentList,
    diveCommentAdd
  },
  data() {
    return {
      titleTop: '',
      title: '潜点',
      backurl: '/dive',
      id: undefined,
      data: undefined,
      biologyList: [],
      commentId: undefined,
      commentType: undefined,
      showAddComment: false,
      center: {
        lng: 116.403941, // 经度
        lat: 39.913948 // 纬度
      },
      centerEnd: {
        lng: 116.403941, // 经度
        lat: 39.913948 // 纬度
      },
      zoom: 15
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.init()
    this.initBiology()
  },
  methods: {
    GetEnbaleDiveComment,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveData/getDivePlace',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.place.placeName
        this.center.lng = this.data.place.longitudeStar
        this.center.lat = this.data.place.latitudeStar
        this.centerEnd.lng = this.data.place.longitudeEnd
        this.centerEnd.lat = this.data.place.latitudeEnd
        setTimeout(() => {
          this.commentType = 'DivePlace'
          this.commentId = this.id
        }, 1)
      })
    },
    initBiology() {
      request({
        url: '/DiveData/getBiologyList',
        method: 'post',
        data: { divePlaceId: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.biologyList = response.data
        this.biologyList.forEach(item => {
          if (item.biology.imgs) {
            item.biology.img = item.biology.imgs.split(',')
          }
        })
      })
    },
    onSelectFish(id) {
      this.$router.push('/dive/biology/' + id)
    }
  }
}
</script>
<style scoped>
.topRect{
    background-color: #fff;
    padding: 1em;
}
.title
{
    padding-top: 1em;
    font-weight: 700;
}
.titleSmall{
    font-size: 0.8em;
    font-weight: 700;
    padding-top: 0.25em;
    padding-bottom: 1em;
}
.topRect .star{
    padding: 0.5em 0;
}
.topRect .addressLine{
    font-size: 0.8em;
    font-weight: 700;
    padding: 0.25em 0;
}
.topRect .mapRect{
    width: 100%;
    height: 50vw;
    background-color: #ccc;
    margin: 1em 0;
}

.topRect .mapRect .rectMap
{
  height: 50vw;
}
.topRect .about{
    font-size: 0.8em;
     color: #999;
}
.topRect .noScore{
    color: #999;
    font-size: 0.7em;
    margin-left: 0.5em;
}

.baseRect{
    padding: 0 1em;
    margin-top: 0.5em;
    background-color: #fff;
}
.baseRect .about{
    font-size: 0.8em;
    color: #999;
    padding-bottom: 1em;
}

.dataRect{
    display: flex;
    flex-wrap: wrap;
}
.dataRect .rect{
    width: calc(50% - 0.5em);
    text-align: center;
    font-size: 0.8em;
    padding-bottom: 1em;

}
.dataRect .rect .img{
    overflow: hidden;
    margin-bottom: 0.5em;
}
.dataRect .name{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.dataRect .from{
    text-align: left;
}
.dataRect .from span{
    margin: 0.25em;
}
.emptyRect{
    line-height: 6em;
    text-align: center;
    color: #999;
    font-size: 0.8em;
}

.comment{
    position: relative;
    border-bottom: 1px solid #f5f5f5;
    margin-bottom: 0.5em;
}
.comment .icon{
    position: absolute;
    left: 0.5em;
    top: 0;
    width: 4em;
}
.comment .Body{
    padding-left: 5em;
}
.comment .Body span{
    font-weight: 700;
    font-size: 0.9em;
}
.comment .Body div{
    padding: 0.25em 0;
    font-size: 0.8em;
    color: #999;
}
.comment .Body .img{
    margin:0.5em 0.5em 0 0;
    overflow: hidden;
}
</style>
